import * as React from "react";
const SvgCheck = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={10} viewBox="0 0 12 10" {...props}><path d="m3.87 7.6-2.8-2.8-.94.93 3.74 3.74 8-8-.94-.94z" /></svg>;
export default SvgCheck;